import flyOverTemplate from '../templates/flyOver.hbs';
import $ from 'jquery';
$.fn.sdaFlyOver = function(data) {
    const that = this;
    const content = that.html();
    let $rp = null;

    data = data || {};
    $.extend(data, that.data());

    that.html(flyOverTemplate(data))
        .find('.fly-over-content')
        .html(content)
        .bind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function() {
            that.hasClass('panel-open') ? '' : that.removeClass('fly-over-visible');
        })
        .sdaInitWidgets();

    $rp = that.find('.sda-right-panel, .sda-right-panel-float');
    if ($rp.length) {
        $rp.sdaRightPanel();
    }

    that.on('open', function(e) {
        e.stopPropagation();
        that.addClass('fly-over-visible');
        setTimeout(function() {
            that.addClass('panel-open');
        }, 10);
    });

    that.on('close', function(e) {
        e.stopPropagation();
        that.removeClass('panel-open');
    });

    return that;
};
